import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import SEOHead from "@/components/layout/SEOHead";
import { PageHero } from "@/pages/About.hero";
import RichHtml from "@/components/RichHtml";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    setState("loading");
    axios.get(`${API}/news/${encodeURIComponent(slug)}`)
      .then(r => { setPost(r.data); setState("ok"); })
      .catch(() => setState("missing"));
  }, [slug]);

  if (state === "loading") return <div className="min-h-[40vh] flex items-center justify-center text-[color:var(--muted)]">Loading…</div>;
  if (state === "missing") return (
    <div className="min-h-[50vh] flex items-center justify-center px-4">
      <div className="text-center">
        <p className="eyebrow mb-3">★ 404</p>
        <h1 className="font-display text-4xl text-[color:var(--blue-ink)]">Post not found</h1>
        <Link to="/news" className="btn-primary mt-6 inline-flex">All news</Link>
      </div>
    </div>
  );

  return (
    <>
      <SEOHead title={post.title} description={post.excerpt || post.title} path={`/news/${post.slug}`} />
      <PageHero eyebrow={post.date} title={post.title} subtitle={post.excerpt || undefined} />
      {post.image_url && (
        <div className="max-w-4xl mx-auto px-5 lg:px-10 mb-6">
          <img src={post.image_url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${post.image_url}` : post.image_url}
               alt="" className="w-full rounded-2xl object-cover" style={{ maxHeight: "480px" }} />
        </div>
      )}
      <section className="bg-white py-10 lg:py-16">
        <div className="max-w-3xl mx-auto px-5 lg:px-10">
          <RichHtml html={post.body} />
          <p className="mt-10">
            <Link to="/news" className="btn-ghost">← All news</Link>
          </p>
        </div>
      </section>
    </>
  );
}
